import {} from '@reown/appkit-common';
import { solana, solanaDevnet, solanaTestnet } from '@reown/appkit/networks';
export const solanaChains = {
    'solana:mainnet': solana,
    'solana:testnet': solanaTestnet,
    'solana:devnet': solanaDevnet
};
export function getStandardChain(caipNetworkId) {
    const standardChain = Object.entries(solanaChains).find(([_, chain]) => chain.caipNetworkId === caipNetworkId);
    return standardChain?.[0];
}
//# sourceMappingURL=chains.js.map